import { RoleType } from '../types/enums';

/** Roles requiring peer attestation */
export const MANAGEMENT_ROLES: RoleType[] = [
  RoleType.MANAGER,
  RoleType.HR,
  RoleType.BAR_RAISER,
  RoleType.SENIOR_LEADER,
];

/** Formats RoleType values into human-friendly labels */
export function formatRoleLabel(role: RoleType): string {
  if (role === RoleType.HR) return 'HR';
  return role
    .toLowerCase()
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}

/**
 * Determines whether the given user is considered an "editor" for the packet
 * (i.e., the packet's Manager or its assigned Senior Leader).
 */
export function isPacketEditor(userId: string | undefined | null, packet: { managerId: string; seniorLeaderId: string; }): boolean {
  if (!userId) return false;
  return userId === packet.managerId || userId === packet.seniorLeaderId;
} 